import React, { useState, useRef, useEffect } from "react";

import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";

import { nextAuction, declaratorNextImage } from "../../Model/DeclaratorModel";
import NoImage from "../../images/resources/noImage.jpg";
import Typography from "@mui/material/Typography";
import "./Center.css";
import { Box, Button } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
export default function TitlebarBelowImageList({ LiveData }) {
  const [count, setCount] = useState(0);
  const [dataNextAuction, setNExtData] = useState([]);

  const ListDatagetNExtAuctionOne = (LiveData, data) => {
    try {
      async function getNExtAuctionOne() {
        const results = await nextAuction(LiveData, data);
        setNExtData(results);
      }
      getNExtAuctionOne().catch(console.error);
    } catch (error) {}
  };

  const increment = (val) => {
    try {
      async function getNextAuction() {
        const ArrayData = {
          auction_id: LiveData.auction_details.auction_id,
          setId: LiveData.auction_details.id,
          LotNo: count + 1,
        };

        const results = await declaratorNextImage(ArrayData);
        setNExtData(results);
        if (results.sucess === false) {
          setNExtData([]);
        } else {
          setNExtData(results);
        }
      }
      getNextAuction().catch((error) => {
      });
    } catch (error) {
    }
  };

  const decrement = (val) => {
    try {
      async function getNextAuction() {
        const ArrayData = {
          auction_id: LiveData.auction_details.auction_id,
          setId: LiveData.auction_details.id,
          LotNo: count - 1,
        };
  
        const results = await declaratorNextImage(ArrayData);
        setNExtData(results);
        if (results.sucess === false) {
          setNExtData([]);
        } else {
          setNExtData(results);
        }
      }
      getNextAuction().catch((error) => {
      });
    } catch (error) {
    }
  };

  const handleClickNextAuction = () => {
    setCount(function (prevCount) {
      return (prevCount += 1);
    });
    return increment();
  };

  const handleClickPrevAuction = () => {
    setCount(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 0);
      }
    });
    return decrement();
  };

  const currentLotRef = useRef(null);

  useEffect(() => {
    try {
      const lotNumber = LiveData.lot.details[0].lot_number;
      setCount(parseInt(lotNumber) + 1);
      if (currentLotRef.current !== lotNumber) {
        console.log("New Lot detected. Fetching next auction data...");
        
        ListDatagetNExtAuctionOne(LiveData);
        currentLotRef.current = lotNumber;
      }
  
    } catch (error) {
      console.error("Effect error:", error);
    }
  
    return () => {
    };
  }, [LiveData]); 

  return (
    <div style={{ padding: 5,   backgroundColor: '#252728', }}>
  <ImageList gap={5} sx={{  display: "flex"}} style={{padding:4}}>
        {dataNextAuction.length ? (
          [...dataNextAuction].sort((a, b) => Number(a.lot_number) - Number(b.lot_number)).map((item,i) => {
            let soldItem;
            
            if (item.lot_status === "UNSOLD") {
              soldItem = <div className="overlayClient" style={{color: 'rgb(251 49 49)',height: "100%"}}>Unsold</div>;
            } else if (item.lot_status === "SOLD") {
              soldItem = <div className="overlayClient" style={{color: 'rgb(4 245 4)',height: "100%"}}>Sold</div>;
            } else if (item.lot_status === "RESERVE_NOT_MET") {
              soldItem = <div className="overlayClient" style={{color: 'rgb(251 49 49)',height: "100%",paddingTop: "50%"}}>Reserve Not Met</div>;
            } else if (item.lot_status === "PASS") {
              soldItem = <div className="overlayClient" style={{color: 'rgb(251 49 49)',height: "100%",paddingTop: "50%"}}>PASS</div>;
              
            } else {
              soldItem = "";
            }
            return (
            


              <ImageListItem key={i} style={{  borderRadius: 5,
                border: "0.5px solid gray",}}>

<img
                    className="imageHover"
                    style={{
                      width: 100,
                      borderTopRightRadius: 4,
                      borderTopLeftRadius: 4,
                    }}
                    srcSet={item.img_url === null ? NoImage : item.img_url}
                    src={item.img_url === null ? NoImage : item.img_url}
                    alt={item.title}
                    loading="lazy"
                  />
                

                <ImageListItemBar
                  style={{ fontSize: 6, maxWidth: 100 }}
                  title={
                    <React.Fragment>
                      <Typography
                        style={{ fontSize: 10 ,color: '#e2e5e9',fontWeight: 'bold'}}
                        component="span"
                        variant="body2"
                        color="text.primary">
                                   
                        {item.lot_number}. {item.title === null ? item.artist:item.title} 
                      </Typography>  
                    </React.Fragment>
                  }
                  subtitle={
                    <React.Fragment>
                      <Typography
                        style={{ fontSize: 9, maxWidth: 100,color: '#e2e5e9',fontWeight: 'bold' }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        {item.artist === null ? item.title:item.artist} 
                      </Typography>
                    </React.Fragment>
                  }
                  subtitle={
                    <React.Fragment>
                    <Typography
                      style={{ fontSize: 9, maxWidth: 100, color: '#e2e5e9', fontWeight: 'bold' }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                      {item.lot_status === "SOLD" ? `HP ₱ ${Number(item.hp).toLocaleString()}` : " "}
                    </Typography>

                    </React.Fragment>
                  }

                  position="below"
                />
  
              </ImageListItem>
    
            
            );
          })
        ) : (
          <Box sx={{ margin: "auto" }}>
                     <Typography style={{color: 'white'}}>Auction End</Typography>
            
          </Box>
        )}

      </ImageList>

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: " translate(-50%, -50%)",
          msTransform: "translate(-50%, -50%)",

          border: "none",
          cursor: "pointer",
          borderRadius: 5,
          textAlign: "center",
          width: "100%",
        }}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "97%",

            margin: "auto",
          }}
        >
             {count === 1 ? <div></div>:
          <div className="nextButton" style={{ borderRadius: 5 }}>
            <Button
              style={{ color: "white" }}
              onClick={() => handleClickPrevAuction()}
              startIcon={<ArrowBackIosIcon style={{ marginLeft: 15 }} />}
            ></Button>
          </div>}

          {dataNextAuction.length < 5 ? "":
          <div className="nextButton" style={{ borderRadius: 5 }}>
            <Button
              className="nextButton"
              style={{ color: "white" }}
              onClick={() => handleClickNextAuction()}
              startIcon={<ArrowForwardIosIcon style={{ marginLeft: 15 }} />}
            >
              {" "}
            </Button>
          </div>}
        </Box>
      </div>
      
    </div>
  );
}
